<!--
  Owner Info Component
  
  Angular 10 Upgrade - Modified by Mihir
  Date: May 7, 2026
  
  Changes Made:
  - REMOVED orphaned formControlName directives (lines 23 & 51 in original)
  
  BEFORE (Angular 9):
  Hidden input fields with formControlName but no parent [formGroup]:
  <div style="width: 0; height: 0; overflow: hidden">
    <input type="text" formControlName="state" id="state" />
  </div>
  
  AFTER (Angular 10):
  Removed entirely - these were not needed and causing errors
  
  Reason for Change:
  Angular 10 has stricter validation for reactive forms. It throws errors when
  formControlName is used without a parent formGroup directive. These hidden
  inputs were not actually needed for functionality.
  
  Error Fixed:
  "formControlName must be used with a parent formGroup directive"
-->

<!-- Filter - Search - Form  -->
<div *ngIf="permissionMap?.owner_info_v" class="data-action-form">
  <div class="row justify-content-between align-items-end">
    <div class="col-12 col-sm-12 col-md-7 col-lg-6 col-xl-5">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-6 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <label>City</label>
            <select class="form-control select2" #city (change)="searchInOwner(city.value, 'city')">
              <option selected="" value="">City</option>
              <option *ngFor="let item of cityData" [value]="item.city">{{ item.city }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <label>State</label>
            <select class="form-control select2" #states (change)="searchInOwner(states.value, 'states')">
              <option selected="" value="">State</option>
              <option *ngFor="let item of statesData" [value]="item.id">{{ item.abbreviation }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md col-lg-4 col-xl px-2">
          <div class="form-group">
            <div class="search-box">
              <div class="form-group">
                <input
                  type="text"
                  #search
                  placeholder="Search"
                  class="form-control fild"
                  (keyup)="searchInOwner(search.value, 'search')" />
                <button type="submit" class="search"><i class="fas fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-5 col-lg-6 col-xl-7">
      <div class="text-right">
        <a href="javascript:;" (click)="generateCSV()" class="btn btn-primary mb-3 mr-2">Export to Excel</a>
        <button
          [disabled]="permissionMap.owner_info_v && !permissionMap.owner_info_e"
          class="btn btn-primary mb-3"
          (click)="openAddEditOwnerInfo()">
          + New Owner
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Filter - Search - Form  End-->
<div *ngIf="userPermissions?.owner_info?.view" class="data-table-scroll-container">
  <div class="table-responsive">
    <table class="table owner-data-table">
      <thead>
        <tr>
          <th>Owner</th>
          <th>Facility/Location</th>
          <th>Street Address</th>
          <th>City</th>
          <th>State</th>
          <th>Zip Code</th>
          <th></th>
        </tr>
      </thead>
      <tbody *ngIf="ownerInfoData.length > 0">
        <tr *ngFor="let item of ownerInfoData">
          <td>{{ item.owner_name }}</td>
          <td>{{ item.facility_name }}</td>
          <td>{{ item.street_address }}</td>
          <td>{{ item.city }}</td>
          <td>{{ item.abbreviation }}</td>
          <td>{{ item.zipcode }}</td>
          <td class="text-right">
            <a
              [class.disabled]="permissionMap.owner_info_v && !permissionMap.owner_info_e"
              href="javascript:void(0);"
              (click)="openAddEditOwnerInfo(item.owner_id)"
              ><i class="far fa-pen"></i
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- Export Job Details Modal -->
<div class="modal fade" id="export-job" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              Are you sure you would like to export the job details? <br />
              Doing this will change the job status to Active.
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closebutton data-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-primary width-fix" (click)="generateCSV()">Export Job Details</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Export Job Details Modal End-->
